import { useLocalization } from '../provider/LocalizationProvider';

/** @deprecated use LocalizationProvider */
/** This uses the hook from LocalizationProvider as a HOC and is only used in class components */
export const withLocalization = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
    const WithLocalization: React.FC<Omit<P, keyof ReturnType<typeof useLocalization>>> = (props) => {
        const { t } = useLocalization();

        return <WrappedComponent {...(props as P)} t={t} />;
    };

    return WithLocalization;
};
